import { render, staticRenderFns } from "./AdminInspirations.vue?vue&type=template&id=cc367d9e&"
import script from "./AdminInspirations.vue?vue&type=script&lang=js&"
export * from "./AdminInspirations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports